<template>
  <div>
    <Tabs value="course" :animated="false">
      <TabPane label="课程" name="course">
        <CourseSelect
          class="course-select"
          :selectType="selectType"
          :selectedItems="courses"
          showCatagory
          :showStatus="false"
          :spellGroup="1"
          :status="status"
          :exceptTypes="['4','9']"
          :not_include_system_course = "1"
          :not_include_public_course = "1"
          @onSelectionChange="onCourseChange"
        ></CourseSelect>
      </TabPane>
      <TabPane label="图书" name="book">
        <BookSelect
          :selectType="selectType"
          :selectedItems="books"
          showCatagory
          :showStatus="false"
          :status="status"
          :spellGroup="1"
          @onSelectionChange="onBookChange"
        ></BookSelect>
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
import CourseSelect from "./CourseSelect.vue";
import BookSelect from "./BookSelect.vue";
export default {
  name: "ShopSelect",
  components: {
    CourseSelect,
    BookSelect
  },
  props: {
    status: {
      type: Number,
      default: 1
    },
    selectType: {
      type: String,
      default: "single"
    },
    selectItems: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      courses: [],
      books: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.courses = this.selectItems.filter(item => item.type == "course");
      this.books = this.selectItems.filter(item => item.type == "book");
    },
    onCourseChange(list) {
      this.courses = list;
      if (this.selectType == "single") {
        this.books = [];
      }
    },
    onBookChange(list) {
      this.books = list;
      if (this.selectType == "single") {
        this.courses = [];
      }
    },
    getSelectItems() {
      let list = [];
      this.books.forEach(item => {
        list.push({ ...item, type: "book", type_name: "图书" });
      });
      this.courses.forEach(item => {
        list.push({
          ...item,
          type: "course",
          type_name: item.course_type_name
        });
      });
      return list;
    }
  },
  watch: {
    selectItems() {
      this.init();
    }
  }
};
</script>
<style lang="scss" scoped>
.course-select {
  /deep/ {
    .search-form {
      padding-top: 0;
    }
  }
}
</style>
